// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"87cd3ac3","185":"cbecd134","454":"e105d9bd","504":"c80c0609","964":"b8fed300"}[chunkId] + ".chunk.js";
};